module.exports = __webpack_public_path__ + "img/MonstersGuidetoJoy-Cover-640.5454e86e.png";